import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlace = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.0003 12.6667C21.0003 9.90835 18.7587 7.66669 16.0003 7.66669C13.242 7.66669 11.0003 9.90835 11.0003 12.6667C11.0003 16.4167 16.0003 21.8334 16.0003 21.8334C16.0003 21.8334 21.0003 16.4167 21.0003 12.6667ZM14.3337 12.6667C14.3337 11.75 15.0837 11 16.0003 11C16.917 11 17.667 11.75 17.667 12.6667C17.667 13.5834 16.9253 14.3334 16.0003 14.3334C15.0837 14.3334 14.3337 13.5834 14.3337 12.6667ZM10.167 22.6667V24.3334H21.8337V22.6667H10.167Z",
		fill: "#8C90F0"
	})
});
export default SvgPlace;
